// extracted by mini-css-extract-plugin
export default {"root":"root--fCpz5","errorMsg":"errorMsg--t8g0e","errorWrap":"errorWrap--hr7t6","btn":"btn--jQpMc","btnIsDisabled":"btnIsDisabled--jWNiJ","btnsWrap":"btnsWrap--OxcjH"};